/*global google*/
import React, { Component } from 'react';
import { Form, Button, Item, Segment, Label, Header, Icon, Comment, Rating, Feed} from 'semantic-ui-react';
import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import axios from 'axios';
import styles from './detail.scss';
import moment from 'moment';

const mapStyle = {
  width: '100%',
  height: '300px',
};

const typemap = {
  'first_hand': 'FIRST HAND',
  'sublease': 'SUBLEASE',
  'roommate_needed': 'ROOMMATE NEEDED'
}

var rrr = 3;

//import { MovieList as MovieListCss, MovieListHeader, Container } from './MovieList.module.scss'
class Detail extends Component {
  constructor() {
    super();
    this.state = {
      house_id: '',
      type: '',
      address: '',
      city: '',
      state: '',
      lat: 0,
      lng: 0,
      bedrooms: 0,
      bathrooms: 0,
      available: 0,
      photo: [],
      cost: 0,
      feature: 0,
      description: '',
      review: [],
      startDate: new Date(),
      endDate: new Date(),
      rating: 0,
      like: 0,
      user_rate: 0,
      form: ''
    };
    this.baseUrl = "http://node-express-env.yhwg8jeyei.us-west-2.elasticbeanstalk.com/api/houses/";
    this.reviewUrl = "http://node-express-env.yhwg8jeyei.us-west-2.elasticbeanstalk.com/api/reviews?house=";
  }

  componentWillMount() {
    const values = this.props.location.pathname;
    let id = values.split('/')[2];
    let url = `${this.baseUrl}${id}`
    axios.get(url).then((response) => {
      var house = response.data.data;
      this.setState({
        house_id: id,
        type: house.type,
        address: house.address,
        city: house.city,
        state: house.state,
        lat: house.latitude,
        lng: house.longitude,
        bedrooms: house.bedrooms,
        bathrooms: house.bathrooms,
        available: house.available,
        rating: house.ratingSum/ house.ratingCount,
        cost: house.cost,
        feature: house.feature,
        description: house.description,
        review: house.review,
        startDate: house.start_Date,
        endDate: house.end_Date,
        photo: house.photo,
      });
      console.log(house.ratingSum, house.ratingCount);
      let url_2 = `${this.reviewUrl}${id}`
      axios.get(url_2).then((response) => {
        var review = response.data.data;
        this.setState({
          review: review
        });
      }).catch((error) => {
        console.log(error);
      });
    }).catch((error) => {
      console.log(error);
    });
  }


  generate_tag =()=>{
    let map = { 0: 'QUIET', 1: 'PET FRIENDLY', 2: 'SMOKE FREE', 3: 'SUITABLE FOR INFANTS',
                4: 'SWIMMING POOL', 5: 'FREE PARKING' };
    let res = [];
    for(let i = 0; i < this.state.feature; i++) {
      if (this.state.feature[i] == '1')
        res.push(
          <Label as='a'>{map[i]} </Label>
        );
    }
    return res;
  }

  like_handler =()=> {
    if (this.state.like == 0) {
      this.setState({like: 1});
      document.getElementById('like').style.color="#F7819F";
    } else {
      this.setState({like: 0});
      document.getElementById('like').style.color="#D2D7D3";
    }
    let user = JSON.parse(localStorage.getItem('user'));
    const userId = user._id;
    const house = this.state.house_id;
    const url = this.baseUrl + house + '/like/' + userId;
    axios.post(url, {}).then((res) =>{
      user.myInterest.push(house);
      localStorage.setItem('user', JSON.stringify(user));
    }).catch((err) =>{
      console.log(err);
    });
  }


  generate_review =()=> {
    let res = [];
    let data = this.state.review || [];
    if (data.length == 0) {
      res.push(
        <Comment>
          <Comment.Text className="no_review">
            NOBODY LEAVES A REVIEW
          </Comment.Text>
        </Comment>
      );
    } else {
      for (let i = 0; i < data.length; i++) {
        res.push(
          <Comment>
            <Comment.Avatar as='a' src='https://img.icons8.com/color/48/000000/user-male-circle.png' />
            <Comment.Content>
              <Comment.Author>{data[i].username}</Comment.Author>
              <Comment.Metadata>
                <div>{moment(data[i].date).format("YYYY-MM-DD HH:mm:ss")}</div>
                <div>
                  <Icon name='star' />
                  {data[i].rating} STAR
                </div>
              </Comment.Metadata>
              <Comment.Text>
                {data[i].description}
              </Comment.Text>
            </Comment.Content>
          </Comment>
        );
      }
    }
    return res;
  }

  rate_handler =(e, {rating, maxRating})=> {
    this.setState({user_rate: rating});
  }

  form_change_handler =(e)=> {
    this.setState({form: e.target.value});
  }

  post_review =()=> {
    var owner = JSON.parse(localStorage.getItem('user'));
    let url = "http://node-express-env.yhwg8jeyei.us-west-2.elasticbeanstalk.com/api/reviews";
    let des = this.state.form;
    let house = this.state.house_id;
    let rating = this.state.user_rate;
    let date = new Date();
    console.log([des, house, rating, owner]);
    axios.post(url, {
      owner: owner._id,
      username: owner.username,
      house: house,
      description: des,
      rating: rating,
      date: date
    }).then((response) => {
      let url_2 = `${this.reviewUrl}${house}`;
      let user = JSON.parse(localStorage.getItem('user'));
      const reviewId = response.data.data._id;
      user.myReview.push(reviewId);
      localStorage.setItem('user', JSON.stringify(user));
      axios.get(url_2).then((response) => {
        var review = response.data.data;
        this.setState({
          review: review
        });
        let url_3 = `${this.baseUrl}${house}`;
        axios.get(url_3).then((response) => {
          var house = response.data.data;
          this.setState({
            rating: house.ratingSum/ house.ratingCount,
          });
        });
      })
    }).catch((error) => {
        console.log(error);
    });
  }

  render() {
    return (
      <div className="detail">
        <div className="map">
          <Map google={this.props.google} zoom={18} style={mapStyle}  center={{lat: this.state.lat, lng: this.state.lng}}>
              <Marker position={{lat: this.state.lat, lng: this.state.lng}} />
          </Map>
        </div>
        <div className="info">
          <div className="info_container">
            <div className="part_one">
              <p className="city">{this.state.city + "·" + this.state.state}</p>
              <Header>{this.state.address}&nbsp;&nbsp;<Label className='type_label'>{typemap[this.state.type]}</Label></Header>
              <div className='room_info'>
                <img className="room_icon" src="https://img.icons8.com/ios/50/000000/double-bed.png"/>
                <p className="room">{this.state.bathrooms + " BEDROOMS"}</p>
                <img className="room_icon" src="https://img.icons8.com/ios/50/000000/bath.png"/>
                <p className="room">{this.state.bathrooms + " BATHROOMS"}</p>
                <img className="room_icon" src="https://img.icons8.com/windows/32/000000/contacts.png"/>
                <p className="room">{this.state.available + " AVAILABLE"}</p>
              </div>
              <div className="feature">
                {this.generate_tag()}
              </div>
            </div>
            <div className="part_two">
              ${this.state.cost}
              <p>/mon</p>
              <Button className="like_button" id='like' onClick={this.like_handler}>
                <Icon name='like'/>
              </Button>
            </div>
            <p className="description">{"\"" + this.state.description + "\""}</p>
            <img className="photo" src={this.state.photo[0]} />
            <Header className="comment_header">REVIEW</Header>
            <Comment.Group className="comment">
              <div>
                <p className='rating_text'>{Math.round(this.state.rating * 10)/10}/5.0</p>
                <Rating size='massive' maxRating={5} rating={this.state.rating} disabled />
              </div>
              {this.generate_review()}
              <Header size='large'>ADD YOUR OPINION</Header>
              <Form className="reply" reply>
                <Rating size='huge' maxRating={5} onRate={this.rate_handler}/>
                <Form.TextArea onChange={this.form_change_handler} />
                <Button content='Add Comment' onClick={this.post_review} labelPosition='left' icon='edit' primary />
              </Form>
            </Comment.Group>
          </div>
          <div className='aaa'>
          <ul>
            <li>
              <a>
                <p>ON RENT FROM</p>
                <p>{moment(this.state.startDate).format('YYYY/MM/DD')}</p>
                <p>TO {moment(this.state.endDate).format('YYYY/MM/DD')}</p>
              </a>
            </li>
            <li>
              <a>
                <p>ONLY {this.state.available} SPOTS AVAILABLE. HURYY UP!</p>
              </a>
            </li>
            <li>
              <a>
                <p>{typemap[this.state.type]}</p>
                <p>${this.state.cost} PER MONTH</p>
              </a>
            </li>
          </ul>
          </div>
        </div>
      </div>

    );
  }
}


export default GoogleApiWrapper({
  apiKey: 'AIzaSyC5S4FIkwJGSLu9FfqIn-hNUJq79mGZRig'
}) (Detail);
